import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function insert(data){
  return request({
    url:applicationName+'/admin/corporateImageList',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deleted(data){
  return request({
    url:applicationName+'/admin/corporateImageList',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deletedIds(ids,data){
  return request({
    url:applicationName+'/admin/corporateImageList/ids',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    params:data,
    data:JSON.stringify(ids)
  })
}

export function queryNumOfTheClassify(data){
  return request({
    url:applicationName+'/admin/corporateImageList/numOfClassify',
    method:'get',
    params:data
  })
}

export function query(data){
  return request({
    url:applicationName+'/admin/corporateImageList',
    method:'get',
    params:data
  })
}

export function queryList(data){
  return request({
    url:applicationName+'/admin/corporateImageList/list',
    method:'get',
    params:data
  })
}

export function update(data){
  return request({
    url:applicationName+'/admin/corporateImageList',
    method:'put',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}